import { useParams } from 'react-router-dom';
import api from '../../services/api';
import { useMutation, useQuery} from "@tanstack/react-query";
import { error } from "../global/ToastAlert";

export const useGetVendor = () => {
    const { vendorId } = useParams();
    const fetchData = async () => {
        const { data } = (vendorId)? await api.get(`/vendors/${vendorId}/?vendorId=${vendorId}`): {data:null};
        return data;
    };
    return useQuery({ queryKey: ['vendor', vendorId], queryFn: fetchData, enabled: true, refetchOnWindowFocus: false });
};


export const useCheckCodeVendor = () => {
    const { vendorId } = useParams();
    const checkCode = async ({data:code, message=null}) => {
        const { data } = await api.post(`/vendors/${vendorId}/codes/?vendorId=${vendorId}`, code);
        if(data && data.code.length === 0 ) error(message, 3000, 'bottom-center');
        return data;
    };
    return useMutation(checkCode)
};


export const useCheckCodeProduct = () => {
    const { vendorId } = useParams();
    const checkCode = async ({data:code, message=null}) => {
        const { data } = await api.post(`/vendors/${vendorId}/source/?vendorId=${vendorId}`, code);
        if(data && data.code.length === 0 ) error(message, 3000, 'bottom-center');
        return data;
    };
    return useMutation(checkCode)
};